import FacebookRoundedIcon from "@mui/icons-material/FacebookRounded";
import InstagramIcon from "@mui/icons-material/Instagram";
import TwitterIcon from "@mui/icons-material/Twitter";
import { IoLocationSharp } from "react-icons/io5";
import { IoIosMail } from "react-icons/io";

export const socialIcon = [
  {
    id: 1,
    icon: <FacebookRoundedIcon />,
  },
  {
    id: 2,
    icon: <InstagramIcon />,
  },
  {
    id: 3,
    icon: <TwitterIcon />,
  },
];

export const footerList = [
  {
    id: 1,
    title: "Company Info",
    list: ["About Us", "Careers", "Blog"],
  },
  {
    id: 2,
    title: "Legal",
    list: ["Privacy Policy", "Terms and Conditions"],
  },
  {
    id: 3,
    title: "Business Services",
    list: [
      "Marketing",
      "Research",
    ],
  },
  {
    id: 4,
    title: "Resources",
    list: ["IOS & Android"],
  },
  {
    id: 5,
    title: "Get In Touch",
    list: [
      {
        type: "address",
        text: [
          "Bodymappr",
          "159 Porchester Terrace Nth.",
          "London W2 6BH United Kingdom",
        ],
        icon: <IoLocationSharp className="icon-location" />,
      },
      {
        type: "email",
        text: "Info@bodymappr.com",
        icon: (
          <IoIosMail
            style={{ fontSize: "1.5rem", color: "#00672F", marginRight: ".5rem" }}
          />
        ),
      },
    ],
  },
];
